import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import useAuth from "hooks/useAuth";
import CampaignManagerTab from "../CampaignManager/CampaignManagerTab";
import { useNavigate } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MartechMainComponent({ page }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const isAdmin = user.permissions.includes("Martech:Admin");
  const isViewer = user.permissions.includes("Martech:View");
  const pageIndex = {
    dashboard: 0,
    "campaign-manager": 1,
    ads: 1,
    "automation-rules": 2,
  };

  useEffect(() => {
    setValue(pageIndex[page] ?? 1);
  }, [page]);

  const [value, setValue] = useState(pageIndex[page] ?? 1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", backgroundColor: "#FFFFFF" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#354887",
            },
            "& .Mui-selected": {
              color: "#354887",
            },
          }}
        >
          <Tab
            label="DASHBOARD"
            //Ir a la pantalla de dashboard
            onClick={() => navigate("/martech/dashboard")}
            // disabled
            {...a11yProps(0)}
            sx={{
              "&.Mui-selected": {
                color: "#354887",
              },
            }}
          />

          <Tab
            label="CAMPAIGN MANAGER"
            //Ir a la pantalla de campaign manager
            onClick={() => navigate("/martech/campaign-manager")}
            {...a11yProps(1)}
            sx={{
              "&.Mui-selected": {
                color: "#354887",
              },
            }}
          />

          <Tab
            disabled={!isAdmin}
            label="AUTOMATION RULES"
            //Ir a la pantalla de automation rules
            onClick={() => navigate("/martech/automation-rules")}
            {...a11yProps(2)}
            sx={{
              "&.Mui-selected": {
                color: "#354887",
              },
            }}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        Dashboard
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <CampaignManagerTab page={page} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        Automation Rules
      </CustomTabPanel>
    </Box>
  );
}
